import { HotelSearchNoResultPropertiesType } from "@website/accommodation-ui/hotel-search/hotel-search-panel/hotel-search-no-result/hotel-search-no-result.types";

export const useHotelSearchNoResult = (
  properties: HotelSearchNoResultPropertiesType
) => {
  const { query } = properties;

  return {
    resultTitle: "نتایج جستجو",
    notFoundtitle: "نتیجه ای یافت نشد.",
    firstDescription: (
      //TODO
      <>
        نتیجه‌ا‌ی برای ”
        <span className="text-on-surface-high-emphasis">{query}</span>” پیدا
        نکردیم.
      </>
    ),
    secondDescription: "با کلمه ی دیگری جستجو کنید."
  };
};
